import React, { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";

const SESSION_FLAG = "astat_floor_monitoring_consent_session";

/**
 * MonitoringConsentGate — mandatory disclaimer shown once per browser
 * session before The Floor renders. Records consent server-side for audit;
 * gates locally via sessionStorage so it re-appears on every fresh login
 * without nagging on every re-render/route change within the same session.
 */
export default function MonitoringConsentGate({ onReady }) {
  const [needed, setNeeded] = useState(false);
  const [ready, setReady] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_FLAG) === "1") {
      onReady();
      setReady(true);
      return;
    }
    setNeeded(true);
    setReady(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const agree = async () => {
    setSubmitting(true);
    try {
      await apiClient.post("/floor/monitoring/consent");
    } catch { /* audit write failed — still let them proceed, don't block the shift */ }
    sessionStorage.setItem(SESSION_FLAG, "1");
    setSubmitting(false);
    setNeeded(false);
    onReady();
  };

  if (!ready || !needed) return null;

  return (
    <div className="monitoring-consent-gate" data-testid="monitoring-consent-gate">
      <div className="mcg-card">
        <div className="mcg-title">WORKSTATION ACTIVITY NOTICE</div>
        <p className="mcg-body">
          While you&apos;re signed in to The Floor, MedexOVA monitors <b>activity level</b> —
          keyboard/mouse activity counts, idle time, and tab focus — to confirm active work
          during paid shifts.
        </p>
        <p className="mcg-body">
          If your camera is enabled, a simple present / not-present signal is computed on
          your own device and reported as a yes/no. <b>No video or images are ever recorded,
          transmitted, or stored.</b> We do not log what you type or view.
        </p>
        <p className="mcg-body mcg-muted">
          A live summary is visible to MedexOVA admins and an end-of-shift report is emailed to
          info@medexova.com. By continuing, you agree to this monitoring for your session.
        </p>
        <button
          className="mcg-agree-btn"
          onClick={agree}
          disabled={submitting}
          data-testid="monitoring-consent-agree-btn"
        >
          {submitting ? "…" : "I Understand & Agree — Continue to The Floor"}
        </button>
      </div>
    </div>
  );
}
